import Invoices from '@mui/icons-material/ReceiptLongOutlined';
import Container from '@mui/material/Container';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import { RootState } from '@/redux/store';
import InvoicesSection from '@/sections/Invoices/index';

const MyInvoices = () => {
  usePageTitle('Mis facturas');

  const { profile } = useSelector((state: RootState) => state.parcel);
  const country = profile.data?.country;
  const navigate = useNavigate();
  useEffect(() => {
    if (country !== 'MEX') {
      navigate('/statistics');
    }
  }, [country]);
  return (
    <Container maxWidth="xxl">
      <SectionTitle title="Mis facturas" mt={5}>
        <Invoices fontSize="large" />
      </SectionTitle>
      <InvoicesSection />
    </Container>
  );
};

export default MyInvoices;
